export enum PartnerStatus {
  Active = "Active",
  Inactive = "Inactive",
  Pending = "Pending"
}

export const PARTNER_STATUS_OPTIONS = [
  { id: PartnerStatus.Active, name: "Active" },
  { id: PartnerStatus.Inactive, name: "Inactive" }
];
